import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=c61d317e&"
import script from "./_id.vue?vue&type=script&lang=js&"
export * from "./_id.vue?vue&type=script&lang=js&"
import style0 from "./_id.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbItem: require('/app/components/breadcrumb/BreadcrumbItem.vue').default,Breadcrumb: require('/app/components/breadcrumb/Breadcrumb.vue').default,Button: require('/app/components/button/Button.vue').default,Link: require('/app/components/link/Link.vue').default,Article: require('/app/components/article/Article.vue').default,Heading: require('/app/components/heading/Heading.vue').default,ListSerial: require('/app/components/list/ListSerial.vue').default,ListRelate: require('/app/components/list/ListRelate.vue').default,Sidebar: require('/app/components/Sidebar.vue').default,PageWrap: require('/app/components/PageWrap.vue').default})
